export default "__VITE_ASSET__BlfJEiGo__"